/**
 * TODO: Remove this file (wrapper). Use localstorage-slim directly with cache-config.js for TTL.
 */

const localStorageSlim = require('localstorage-slim');

const STORAGE_KEYS = Object.freeze({
	USER_ZIP_CODE: 'user_zip_code',
	SUPPLIER_V1: 'rp:supplier:v1'
});

/**
 * @param {string} key
 * @returns {string|object|null}
 */
const getItem = (key) => {
	try {
		return localStorageSlim.get(key);
	} catch (e) {
		return null;
	}
};

/**
 * @param {string} key
 * @param {string|object} value
 * @param {{ ttl?: number }} [options]
 * @returns {void}
 */
const setItem = (key, value, options = {}) => {
	try {
		const hasTtl =
			options.ttl !== null && options.ttl !== undefined && options.ttl >= 0;
		const opts = hasTtl ? { ttl: options.ttl } : {};
		localStorageSlim.set(key, value, opts);
	} catch (e) {
		// no-op
	}
};

/**
 * @param {string} key
 * @returns {void}
 */
const removeItem = (key) => {
	try {
		localStorageSlim.remove(key);
	} catch (e) {
		// no-op
	}
};

module.exports = {
	getItem,
	setItem,
	removeItem,
	STORAGE_KEYS
};
